const baseSaleDealApiUrls = "/api/SalesDeals";

export const SaleDealApiUrls = {
  GetSalesDeals: `${baseSaleDealApiUrls}/Get`,
  GetSalesDealHistory: `${baseSaleDealApiUrls}/GetHistory`,
  AddSalesDeal: `${baseSaleDealApiUrls}`,
  UpdateSalesDeal: `${baseSaleDealApiUrls}/Update`,
};
